import type { ChipProps, Theme } from '@material-ui/core'
import { Chip, makeStyles } from '@material-ui/core'
import classnames from 'classnames'
import React from 'react'

const useStyles = makeStyles<Theme, SelectableChipSmallProps>((theme) => ({
  root: {
    borderRadius: theme.borderRadius.md,
    overflow: 'hidden',
    minWidth: '70px',
    backgroundColor: ({ variant }) =>
      variant === 'outlined' ? 'transparent' : theme.paintscout.palette.brand.Neutral.P96,
    border: ({ variant }) =>
      variant === 'outlined' ? `1px solid ${theme.paintscout.palette.brand.Neutral.P80}` : '1px solid transparent',
    cursor: 'pointer',
    '& > span': {
      padding: theme.spacing(0, 1)
    },
    '&:hover': {
      backgroundColor: theme.paintscout.palette.brand.Neutral.P90
    }
  },
  selected: {
    color: theme.palette.common.white,
    backgroundColor: `${theme.paintscout.palette.primary} !important`,
    border: `1px solid ${theme.paintscout.palette.primary} !important`
  }
}))

export interface SelectableChipSmallProps extends Omit<ChipProps, 'variant'> {
  label: string
  selected: boolean
  onClick: () => void
  variant?: 'filled' | 'outlined'
  loading?: boolean
}

export default function SelectableChipSmall(props) {
  const classes = useStyles(props)
  const { label, selected, onClick, ...chipProps } = props
  return (
    <Chip
      {...chipProps}
      className={classnames({ [classes.root]: true, [classes.selected]: selected })}
      label={label}
      onClick={onClick}
    />
  )
}
